import React, {useEffect} from "react";
import {observer} from "mobx-react";
import {RouteButtons} from "../common/route-tabs/route.buttons";
import {ComponentPropsFromRoute} from "../../routers/routers";
import {useTranslate} from "../../hooks/translate.hook";
import {Space, Typography} from "antd";

export const Settings: React.FC<ComponentPropsFromRoute> = observer(({routeChildren}) => {

    const t = useTranslate();

    return (
        <Space direction={"vertical"} size={[30, 30]}>
            <Typography.Title level={3} style={{margin: 0}}>
                {t("PROPERTY.MAIN.TITLE")}
            </Typography.Title>

            <RouteButtons routes={routeChildren!} />
        </Space>
    )
});